import React, { Fragment, useContext, useEffect } from 'react'
import { PermissionsContext } from '../../providers/permissions'
import { string } from 'prop-types'
const RequireAuth = ({ token }) => {
  const { setToken } = useContext(PermissionsContext)

  const init = async () => {
    setToken(token)
  }
  useEffect(() => {
    init()
  }, [])
  return <Fragment></Fragment>
}

RequireAuth.propTypes = {
  token: string
}

export default RequireAuth
